import { useSignalEffect } from "@preact/signals-react";
import { darkModeEnabled } from "../components/Common/Store/CommonSignals";

/**
 * Hook that applies the theme based on the darkModeEnabled signal.
 * Sets the data-theme attribute on the document element for CSS variable switching.
 */
export const useTheme = () => {
  useSignalEffect(() => {
    const theme = darkModeEnabled.value ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", theme);
  });
};
